import { Container, Stack, TextField } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { DataGrid } from "@mui/x-data-grid";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { create, excelDownload, uploadFile } from "../../redux/actions/student";
import Header from "../common/Header";

export default function StudentInformationRegister() {
  const columns = [
    {
      field: "serialNumber",
      headerName: "通し番号",
      width: 100,
      editable: true,
      headerClassName: "headerColor",
      sortable: false
    },
    { field: "grade", headerName: "年", width: 10, editable: true, headerClassName: "headerColor", sortable: false },
    {
      field: "classNumber",
      headerName: "組",
      width: 10,
      editable: true,
      headerClassName: "headerColor",
      sortable: false
    },
    { field: "number", headerName: "番", width: 10, editable: true, headerClassName: "headerColor", sortable: false },
    { field: "name", headerName: "氏名", width: 180, editable: true, headerClassName: "headerColor", sortable: false },
    {
      field: "password",
      headerName: "パスワード",
      width: 120,
      editable: true,
      headerClassName: "headerColor",
      renderCell: params => {
        const password = params.value;
        const maskedPassword = "*".repeat(password.length);
        return (
          <span>
            {maskedPassword}
          </span>
        );
      },
      sortable: false
    },
    {
      field: "email",
      headerName: "メールアドレス",
      width: 257,
      editable: true,
      headerClassName: "headerColor",
      sortable: false,
      flex: 1
    }
  ];

  const rows = [
    { id: "1", serialNumber: "", grade: "", class: "", number: "", name: "", password: "", email: "" },
    { id: "2", serialNumber: "", grade: "", class: "", number: "", name: "", password: "", email: "" },
    { id: "3", serialNumber: "", grade: "", class: "", number: "", name: "", password: "", email: "" },
    { id: "4", serialNumber: "", grade: "", class: "", number: "", name: "", password: "", email: "" },
    { id: "5", serialNumber: "", grade: "", class: "", number: "", name: "", password: "", email: "" }
  ];

  const [gridData, setGridData] = useState(rows);

  const handleGridDataChange = params => {
    const { id, field, value } = params;
    setGridData(prevData => {
      const newData = prevData.map(row => {
        if (row.id === id) {
          return { ...row, [field]: value };
        }
        return row;
      });
      return newData;
    });
  };

  const Input = styled("input")({
    display: "none"
  });

  const dispatch = useDispatch();
  const registSubmit = () => {
    dispatch(create(gridData));
  };

  const [file, setFile] = useState(null);
  const handleOnChange = e => {
    console.log(e.target.files[0]);
    setFile(e.target.files[0]);
  };

  const uploadFileSubmit = async () => {
    if (!file) {
      alert("ファイルが選択されていません。");
      return;
    }

    try {
      const excelFile = await readFileAsBase64(file);
      const params = { excelFile, fileName: file.name };

      dispatch(uploadFile(params));
    } catch (error) {
      console.error("ファイルのアップロードエラー:", error);
      alert("ファイルのアップロード中にエラーが発生しました。");
    }
  };

  const readFileAsBase64 = file => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result.replace(/^data:.*\/.*;base64,/, ""));
      };
      reader.onerror = error => {
        reject(error);
      };
      reader.readAsDataURL(file);
    });
  };

  const handleDownload = () => {
    dispatch(excelDownload());
  };
  return (
    <Box>
      <Header />
      <Container maxWidth="xl">
        <Box
          sx={{
            mt: 4,
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Typography component="h3" variant="h7" align="left">
            生徒情報登録
          </Typography>
        </Box>
        <Box
          sx={{
            margin: 2,
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Typography component="h4" variant="h7" align="left">
            新規に生徒名簿を作成する場合はこちら
          </Typography>
        </Box>
        <Box
          sx={{
            margin: 2,
            display: "flex",
            flexDirection: "column",
            bgcolor: "#fff9c4"
          }}
        >
          <Box
            sx={{
              mt: 1,
              alignItems: "left",
              justifyContent: "left",
              paddingLeft: 2
            }}
          >
            <Typography component="h4" variant="h7" align="left">
              名簿入力
            </Typography>
          </Box>
          <Box sx={{ alignItems: "center", justifyContent: "center", m: 2 }}>
            <Container maxWidth="md">
              <div
                style={{
                  height: 330,
                  width: "100%",
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                <DataGrid
                  sx={{
                    bgcolor: "white",
                    "& .headerColor": {
                      backgroundColor: "#ffcc80"
                    }
                  }}
                  rows={gridData}
                  columns={columns}
                  onCellEditCommit={handleGridDataChange}
                  hideFooter={true}
                />
              </div>
            </Container>
          </Box>
        </Box>

        <Container maxWidth="sm">
          <Stack sx={{}} direction="row" spacing={5} justifyContent="center" paddingBottom={2}>
            <Button type="submit" variant="contained" sx={{ bgcolor: "#82b1ff", width: "50%" }} onClick={registSubmit}>
              登録
            </Button>
          </Stack>
        </Container>
        <Box
          sx={{
            margin: 2,
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Typography component="h4" variant="h7" align="left">
            作成済みの生徒名簿から取り込む場合はこちら
          </Typography>
        </Box>
        <Box
          sx={{
            margin: 2,
            display: "flex",
            flexDirection: "column",
            bgcolor: "#fff9c4"
          }}
        >
          <Box
            sx={{
              mt: 1,
              alignItems: "left",
              justifyContent: "left",
              paddingLeft: 2
            }}
          >
            <Typography component="h4" variant="h7" align="left">
              エクセルから取り込む
            </Typography>
            <Typography component="h6" variant="h7" align="left">
              参照ボタンからファイルを選択してください
            </Typography>
          </Box>
          <Box sx={{ alignItems: "center", justifyContent: "center", m: 2 }}>
            <Container maxWidth="md">
              <div className="App">
                <label>
                  <Input type="file" onChange={handleOnChange} />
                  <TextField
                    sx={{ bgcolor: "#ffffff" }}
                    hiddenLabel
                    id="outlined-hidden-label-small"
                    value={file ? file.name : ""}
                    variant="outlined"
                    size="small"
                    bgcolor="#ffffff"
                  />
                  <Button
                    component="span"
                    variant="contained"
                    size="medium"
                    sx={{ bgcolor: "#82b1ff", marginLeft: "auto", ml: 3 }}
                  >
                    参照
                  </Button>
                  <Button
                    variant="contained"
                    size="medium"
                    sx={{ bgcolor: "#82b1ff", marginLeft: "auto", ml: 3 }}
                    onClick={handleDownload}
                  >
                    サンプル
                  </Button>
                </label>
              </div>
            </Container>
          </Box>
        </Box>
        <Container maxWidth="sm">
          <Stack sx={{}} direction="row" spacing={5} justifyContent="center">
            <Button variant="contained" sx={{ bgcolor: "#82b1ff", width: "50%" }} onClick={uploadFileSubmit}>
              取り込む
            </Button>
          </Stack>
        </Container>
        <Box sx={{ alignItems: "right", justifyContent: "right", m: 2, display: "flex" }}>
          <Button variant="contained" size="medium" href="/StaffMenu" sx={{ bgcolor: "#82b1ff", marginLeft: "auto" }}>
            戻る
          </Button>
        </Box>
      </Container>
    </Box>
  );
}
